import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';

export default class AgogoWatchBanner extends Component {
  view() {
    return (
      <div className="AgogoWatchBanner">
        <div className="container">
          <i className="fas fa-user-secret"></i>
          {' '}
          {app.translator.trans('florcarioca-rsvp.forum.agogo_watch.message')}
        </div>
      </div>
    );
  }
}
